<div class="p-d-flex p-flex-column">

  <ng-container *ngIf="jeFaktura" [ngTemplateOutlet]="faktura">
  </ng-container>

  <ng-container *ngIf="jeAvansaFaktura" [ngTemplateOutlet]="avansniRacun">
  </ng-container>

  <ng-container *ngIf="jeDokumentOSmanjenju" [ngTemplateOutlet]="dokumentOSmanjenju">
  </ng-container>

  <ng-container *ngIf="jeDokumentOPovecanju" [ngTemplateOutlet]="dokumentOPovecanju">
  </ng-container>

  <ng-container *ngIf="jePredracun" [ngTemplateOutlet]="predracun">
  </ng-container>

  <ng-container *ngIf="jeOtpremnica" [ngTemplateOutlet]="otpremnica">
  </ng-container>
</div>

<ng-template #faktura>
  <!-- Mesto prometa i Datum prometa -->
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <kodit-text-input-field formCtrlId="mesto-prometa" formCtrlLabel="Mesto prometa"
      [formCtrl]="racunFormGroup.controls.mestoPrometa" class="flex-1"></kodit-text-input-field>

    <div class="p-field flex-1">
      <label for="datum-prometa" kodit-form-label>Datum prometa:</label>
      <kodit-calendar formCtrlId="datum-prometa" [formCtrl]="racunFormGroup.controls.datumPrometa"></kodit-calendar>
    </div>
  </div>

  <!-- Mesto izdavanja, Rok placanja, Datum dospeća -->
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid mt-2">
    <kodit-text-input-field class="flex-2" formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      [formCtrl]="racunFormGroup.controls.mestoIzdavanja"></kodit-text-input-field>

    <div class="p-field flex-1">
      <label for="rok" kodit-form-label>Rok plaćanja</label>
      <kodit-rok-vazenja-input formCtrlId="rok"
        [formCtrl]="racunFormGroup.controls.rokPlacanja"></kodit-rok-vazenja-input>
    </div>
    <div class="p-field flex-1" *ngIf="jeIzlazna">
      <label for="datum-valute" kodit-form-label>Datum dospeća</label>
      <kodit-calendar formCtrlId="datum-valute" [formCtrl]="racunFormGroup.controls.datumValute"></kodit-calendar>
    </div>
    <!--datum izdavanja-->
    <div class="p-field flex-1" *ngIf="jeUlazna">
      <label for="datum-izdavanja" kodit-form-label>Datum izdavanja</label>
      <kodit-calendar formCtrlId="datum-izdavanja" [formCtrl]="racunFormGroup.controls.datumIzdavanja"></kodit-calendar>
    </div>
  </div>

  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid mt-2" *ngIf="jeIzlazna">
    <div class="p-field flex-1">
      <label kodit-form-label>PDV obaveza za izdavaoca</label>
      <div class="flex align-items-center ">
        <div class="flex align-items-center">
          <p-radioButton name="pdvObaveza" [value]="true"
            [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca" [disabled]="!uSistemuPDV"></p-radioButton>
          <label class="p-ml-2 cursor-pointer"
            (click)="setPdvObaveza(true)">PDV se obračunava</label>
        </div>
        <div class="flex align-items-center p-mt-1">
          <p-radioButton name="pdvObaveza" [value]="false"
            [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca"></p-radioButton>
          <label class="p-ml-2 cursor-pointer"
            (click)="setPdvObaveza(false)">Ne nastaje obaveza</label>
        </div>
      </div>
    </div>
    <kodit-datum-obracuna-pdv-dropdown *ngIf="racunFormGroup.controls.pdvObavezaZaIzdavaoca.value"
      [formCtrl]="racunFormGroup.controls.datumObracunaPdv" formCtrlId="datum-obracuna-pdv"
      class="flex-50"></kodit-datum-obracuna-pdv-dropdown>
  </div>

</ng-template>

<ng-template #avansniRacun>
  <!-- Mesto izdavanja i Datum avansne uplate -->
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <kodit-text-input-field formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      [formCtrl]="racunFormGroup.controls.mestoIzdavanja" class="flex-1"></kodit-text-input-field>

    <div class="p-field flex-1">
      <label for="datum-valute" kodit-form-label>Datum avanse uplate:</label>
      <kodit-calendar formCtrlId="datum-valute" [formCtrl]="racunFormGroup.controls.datumValute"></kodit-calendar>
    </div>
  </div>
  <div class="p-field flex-1" *ngIf="jeIzlazna">
    <label kodit-form-label>Nastanak PDV obaveze za izdavaoca</label>
    <div class="flex align-items-center ">
      <div class="flex align-items-center">
        <p-radioButton name="pdvObaveza" [value]="true"
          [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca"></p-radioButton>
        <label class="p-ml-2 cursor-pointer"
          (click)="racunFormGroup.controls.pdvObavezaZaIzdavaoca.patchValue(true)">PDV se obračunava</label>
      </div>
      <div class="flex align-items-center p-mt-1">
        <p-radioButton name="pdvObaveza" [value]="false"
          [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca"></p-radioButton>
        <label class="p-ml-2 cursor-pointer"
          (click)="racunFormGroup.controls.pdvObavezaZaIzdavaoca.patchValue(false)">Ne nastaje obaveza obračuna
          PDV</label>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #dokumentOSmanjenju>
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <!--mesto izdavanja-->
    <kodit-text-input-field formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      [formCtrl]="racunFormGroup.controls.mestoIzdavanja" class="flex-1"></kodit-text-input-field>
    <!--datum smanjenja-->
    <div class="p-field flex-1">
      <label for="datum-prometa" kodit-form-label>Datum smanjenja: </label>
      <kodit-calendar formCtrlId="datum-prometa" [formCtrl]="racunFormGroup.controls.datumPrometa"></kodit-calendar>
    </div>
  </div>
</ng-template>

<ng-template #dokumentOPovecanju>
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <kodit-text-input-field formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      [formCtrl]="racunFormGroup.controls.mestoIzdavanja" class="flex-1"></kodit-text-input-field>

    <div class="p-field flex-1">
      <label for="datum-valute" kodit-form-label>Datum dospeća (valute)</label>
      <kodit-calendar formCtrlId="datum-valute" [formCtrl]="racunFormGroup.controls.datumValute"></kodit-calendar>
    </div>
  </div>

  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid mt-2" *ngIf="jeIzlazna">
    <div class="p-field flex-1">
      <label kodit-form-label>PDV obaveza za izdavaoca</label>
      <div class="flex align-items-center ">
        <div class="flex align-items-center">
          <p-radioButton name="pdvObaveza" [value]="true"
            [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca"></p-radioButton>
          <label class="p-ml-2 cursor-pointer"
            (click)="racunFormGroup.controls.pdvObavezaZaIzdavaoca.patchValue(true)">PDV se obračunava</label>
        </div>
        <div class="flex align-items-center p-mt-1">
          <p-radioButton name="pdvObaveza" [value]="false"
            [formControl]="racunFormGroup.controls.pdvObavezaZaIzdavaoca"></p-radioButton>
          <label class="p-ml-2 cursor-pointer"
            (click)="racunFormGroup.controls.pdvObavezaZaIzdavaoca.patchValue(false)">Ne nastaje obaveza</label>
        </div>
      </div>
    </div>
    <div class="flex flex-column gap-2 flex-1">
      <kodit-datum-obracuna-pdv-dropdown
        [formCtrl]="racunFormGroup.controls.datumObracunaPdv" formCtrlId="datum-obracuna-pdv"
        class="p-field"></kodit-datum-obracuna-pdv-dropdown>
      <div class="p-field p-mt-3 flex-1"
        *ngIf="racunFormGroup.controls.datumObracunaPdv.value == datumObracunaDanPrometa">
        <label for="datum-ugovora" kodit-form-label>Datum povećanja - ugovor</label>
        <kodit-calendar formCtrlId="datum-ugovora" [formCtrl]="racunFormGroup.controls.datumUgovora"></kodit-calendar>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #predracun>
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <kodit-text-input-field formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      [formCtrl]="racunFormGroup.controls.mestoIzdavanja" class="flex-1"></kodit-text-input-field>
    <!--rok vazenja-->
    <div class="p-field flex-1">
      <label for="rok" kodit-form-label>Rok važenja</label>
      <kodit-rok-vazenja-input formCtrlId="rok" [formCtrl]="rokVazenjaCtrl"></kodit-rok-vazenja-input>
    </div>
  </div>
</ng-template>

<ng-template #otpremnica>
  <!-- Mesto prometa i Datum prometa -->
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <kodit-text-input-field formCtrlId="mesto-prometa" formCtrlLabel="Mesto prometa"
      [formCtrl]="racunFormGroup.controls.mestoPrometa" class="flex-1"></kodit-text-input-field>

    <div class="p-field flex-1">
      <label for="datum-prometa" kodit-form-label>Datum prometa:</label>
      <kodit-calendar formCtrlId="datum-prometa" [formCtrl]="racunFormGroup.controls.datumPrometa"></kodit-calendar>
    </div>
  </div>
  <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
    <!--mesto izdavanja-->
    <kodit-text-input-field class="flex-1" formCtrlId="mesto-izdavanja" formCtrlLabel="Mesto izdavanja"
      formCtrlLabel="Mesto izdavanja" [formCtrl]="racunFormGroup.controls.mestoIzdavanja"></kodit-text-input-field>

    <!--datum izdavanja-->
    <div class="p-field flex-1">
      <label for="datum-izdavanja" kodit-form-label>Datum izdavanja</label>
      <kodit-calendar formCtrlId="datum-izdavanja" [formCtrl]="racunFormGroup.controls.datumIzdavanja"></kodit-calendar>
    </div>
    <div class="p-field flex-1">
      <label for="rok" kodit-form-label>Rok plaćanja</label>
      <kodit-rok-vazenja-input formCtrlId="rok"
        [formCtrl]="racunFormGroup.controls.rokPlacanja"></kodit-rok-vazenja-input>
    </div>
  </div>

</ng-template>
